import { useContext, FC, useState } from 'react'

import SidebarContext, { FilterDate, FilterGroupForDatesContext } from './Context'

type Props = {
  onSubmitFilter: (values: any) => void
  children: JSX.Element
}

const FilterGroupForDatesProvider: FC<Props> = ({ onSubmitFilter, children }) => {
  const [filterDate, setFilterDate] = useState<FilterDate>({ label: '', value: '' })

  return <SidebarContext.Provider value={{ filterDate, setFilterDate, onSubmitFilter }}>{children}</SidebarContext.Provider>
}

export default FilterGroupForDatesProvider

export const useFilterGroupForDates = () => useContext<FilterGroupForDatesContext>(SidebarContext)
